import { ThreeDotsAppLoader } from '../..';
import loadableWithRetry from '../LoadableWithRetry';

export default loadableWithRetry(
  () =>
    import(
      /* webpackChunkName: "public/app" */
      './App'
    ),
  {
    fallback: <ThreeDotsAppLoader />,
  }
);
